import { GRAY_8 } from './mc-tokens';

export const MODUS_CUSTOM_DATEPICKER_STYLESHEET = `
modus-wc-date .calendar-icon-button modus-wc-icon {
  display: flex;
  align-items: center;
  justify-content: center;
}

modus-wc-date .calendar-icon-button modus-wc-icon i {
  color: ${GRAY_8};
  line-height: 1;
}
`;
